module.exports = __webpack_public_path__ + "static/media/clc_location.58838913.png";